import { CircularProgress, Switch, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import BannerImg from '../../../Assets/images/Activation/activationBanner.webp';
import BannerIpadImg from '../../../Assets/images/Activation/activationBannerIPad.webp';
import failedIcon from '../../../Assets/images/Activation/failed.svg';
import infoIcon from '../../../Assets/images/Activation/info_icon.svg';
import successIcon from '../../../Assets/images/Activation/success.svg';
import ButtonNew from '../../../components/Button/Button';
import Footer from '../../../components/Footer/Footer';
import PostHeader from '../../../components/Header/PostHeader';
import SimpleHeader from '../../../components/Header/simpleHeader';
import TextFieldComponent from '../../../components/Textfield/TextField';
import { globalVal } from '../../../global/globalvalues';
import { seoData } from '../../../global/seoData';

// import { otp } from '../../../store/postActivation/actions';
import { GetCustomer } from '../../../store/Checkout/actions';
import { accStatus, otp, settingsPageReset } from '../../../store/PostActivation/actions';
import './settings.scss';
type initialProps = {
    history: any;
};

function Settings(props: initialProps) {
    const [customerDetails, setCustomerDetails] = useState<any>(null);
    const configState = useSelector((state: any) => state.billing.config);
    const [accAccess, setAccAccess] = useState([]);
    const [accLock, setAccLock] = useState<boolean>(false);
    const [showUnlockContent2, setShowUnlockContent2] = useState<boolean>(false);
    const [showUnlockContent1, setShowUnlockContent1] = useState<boolean>(false);
    const [unlockSucces, setUnlockSuccess] = useState<boolean>(false);
    const [otpNum, setOtpNum] = useState('');
    const { postActivation } = useSelector((state: any) => state);
    // const { getCustomer } = useSelector((state: any) => state.checkout);
    const [checkOtpConfirm, setCheckOtpConfirm] = useState<boolean>(false);
    // const [accLocked, setAccLocked] = useState<boolean>(false);
    const [otpErr, setOtpErr] = useState('');
    const [accountLockScreen, setAccountLockScreen] = useState<boolean>(false);
    const [accountLockUnsuccess, setAccountLockUnsuccess] = useState<boolean>(false);
    const [enableResendOtpBtn, setEnableResendOtpBtn] = useState<boolean>(false);
    const [resendOtpLoader, setResendOtpLoader] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
        if (counter === 0) {
            setEnableResendOtpBtn(true);
        } else {
            setEnableResendOtpBtn(false);
        }
    }, [counter]);

    useEffect(() => {
        window.scroll(0, 0);
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        localStorage.removeItem('secondaryCustomerDetail');
        setCustomerDetails(customerDetails);
        if (customerDetails && customerDetails?.accAccessLock?.length > 1) {
            setAccAccess(customerDetails.accAccessLock);
            setAccLock(true);
        } else {
            setAccLock(false);
        }

        return () => {
            dispatch(settingsPageReset({}));
        };
    }, []);

    useEffect(() => {
        if (postActivation && postActivation.otp && postActivation.otp.status === 'SUCCESS') {
            if (postActivation.otp.data.msg === 'OTP_ATTEMPTS_EXCEEDED') {
                setOtpErr('Wrong OTP Entered.');
                setCheckOtpConfirm(false);
            } else if (postActivation.otp.data.msg === 'OTP_TIME_OUT') {
                setOtpErr('OTP expired. Please regenerate another OTP.');
                setCheckOtpConfirm(false);
            } else if (postActivation.otp.data.msg === 'WRONG_OTP_ENTERED') {
                setOtpErr('Invalid OTP.');
                setCheckOtpConfirm(false);
            } else {
                setUnlockSuccess(true);
                setCheckOtpConfirm(false);
                setShowUnlockContent2(false);
                dispatch(GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }));
            }
        }
    }, [postActivation.otp]);

    useEffect(() => {
        if (postActivation && postActivation.accStatus && postActivation.accStatus.status === 'SUCCESS') {
            if (postActivation.accStatus.data.msg === 'LOCKED') {
                // setAccLocked(true);
                setAccLock(true);
                setLoader(false);
                dispatch(GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }));
            } else if (postActivation.accStatus.data.msg === 'OTP_SENT') {
                setResendOtpLoader(false);
                setCounter(15);
                setCheckOtpConfirm(false);
                setShowUnlockContent1(false);
                setShowUnlockContent2(true);
            }
        }
        if (postActivation && postActivation.errorAccStatus && postActivation.errorAccStatus.status === 'FAILURE') {
            setAccountLockUnsuccess(true);
            setLoader(false);
            setAccountLockScreen(true);
            setResendOtpLoader(false);
        }
    }, [postActivation.accStatus, postActivation.errorAccStatus]);

    const handleLockChange = (accLock: boolean) => {
        console.log(accAccess);
        accLockHandler(accLock);
    };

    const accLockHandler = (accLock: boolean) => {
        setLoader(true);
        if (!accLock) {
            setShowUnlockContent1(false);
            const payload: any = {
                customerId: customerDetails.id,
                lockStatus: 'ACC_LOCK',
            };
            dispatch(accStatus(payload));
            return;
        } else {
            setAccountLockScreen(true);
            setShowUnlockContent1(true);
        }
    };

    const unlockMyAccount = () => {
        setOtpNum('');
        setOtpErr('');
        setCheckOtpConfirm(true);
        const payload: any = {
            customerId: customerDetails.id,
            lockStatus: 'ACC_UNLOCK',
        };
        dispatch(accStatus(payload));
    };

    const resendOtpHandler = () => {
        setResendOtpLoader(true);
        const payload: any = {
            customerId: customerDetails.id,
            lockStatus: 'ACC_UNLOCK',
        };
        dispatch(accStatus(payload));
    };

    const confirmOtpHandler = (otpNumber: any) => {
        setCheckOtpConfirm(true);
        if (otpNumber.length < 6 || otpNumber === '') {
            setOtpErr('Otp numbers should be 6 digits.');
            setCheckOtpConfirm(false);
            return;
        }
        const payload: any = {
            customerId: customerDetails.id,
            lockStatus: 'ACC_UNLOCK',
            otp: otpNum,
        };
        dispatch(otp(payload));
    };

    const handleCancelBtn = () => {
        setAccLock(true);
        setShowUnlockContent1(false);
        setAccountLockScreen(false);
        setLoader(false);
    };

    const otpHandler = (e: any) => {
        setOtpNum(e.target.value);
    };

    const continueHandler = () => {
        setUnlockSuccess(false);
        setAccountLockScreen(false);
        setLoader(false);
        setAccLock(false);
    };

    return (
        <div className="helpMain">
            <Helmet>
                <title>{seoData.help.title}</title>
                <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta property="og:title" name="title" content={seoData.help.title} />
                <meta property="og:description" name="description" content={seoData.help.description} />
                <meta name="description" content={seoData.help.description} />
                <meta name="keywords" content={seoData.help.keywords} />
                <meta name="robots" content="noindex, nofollow" />
                <meta property="twitter:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta name="twitter:title" content={seoData.help.title} />
                <meta name="twitter:description" content={seoData.help.description} />
                <link rel="canonical" href={seoData.help.canonicalUrl} />
            </Helmet>
            {customerDetails &&
            (customerDetails.status == 1 ||
                customerDetails.status == 2 ||
                customerDetails.status == 3 ||
                customerDetails.status == 4 ||
                customerDetails.status == 5 ||
                customerDetails.status == 8 ||
                customerDetails.status == 9 ||
                customerDetails.status == 10) ? (
                <PostHeader
                    history={props.history}
                    showServiceTab={configState?.data?.configs?.SERVICE_TAB === 'ENABLE' ? true : false}
                    // enableServiceInPrimarySus={configState?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED}
                />
            ) : (
                <SimpleHeader history={props.history} isHelp={true} user={customerDetails} />
            )}
            <div className="bannerImg" style={{ margin: 0 }}>
                <img src={BannerImg} alt="img" className="WebImg" />
                <img src={BannerIpadImg} alt="img" className="IpadImg" />
                <div className="contentCarousel">
                    <h1 style={{ display: 'none' }}>Account Info</h1>
                    <div className="Goodbye-mobile-store">Settings</div>
                </div>
            </div>

            {!accountLockScreen && (
                <div className="settingsOuter">
                    <div className="settingsTitle">Account Info</div>
                    {loader ? (
                        <>
                            <div className="loaderCheck">
                                <CircularProgress />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="settingsContent">
                                <div className="AccountLineCard">
                                    <div className="AccountTopDiv">
                                        <div className="AccountCusDetails">
                                            <span className="username">Account lock</span>
                                            <span>
                                                <Tooltip title="Enabling account lock blocks actions such as involuntary SIM swaps and port outs, reducing the risk of SIM fraud.">
                                                    <img src={infoIcon} />
                                                </Tooltip>
                                            </span>
                                        </div>

                                        <div className="AccountCusRightDiv">
                                            <div>
                                                <Switch
                                                    checked={accLock ? true : false}
                                                    onChange={() => handleLockChange(accLock)}
                                                    // disabled={false}
                                                    name="pausedata"
                                                    inputProps={{
                                                        'aria-label': 'primary checkbox',
                                                    }}
                                                />
                                            </div>
                                            <div className="AccountDataText">{accLock ? 'Locked' : 'Unlocked'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}
            {/* unlock account next step */}
            {showUnlockContent1 && (
                <div className="settingsOuter">
                    <div className="settingsTitle">Confirm Account Unlock</div>
                    <div className="settingsContent1 mb-3">
                        Unlocking the account requires a One Time Password, which will be sent to your primary email
                        address {customerDetails ? customerDetails.emailId : ''}. Please ensure you have access to this
                        email before proceeding.
                    </div>
                    <ButtonNew className="supportCTA" primary={true} onClick={() => unlockMyAccount()}>
                        {checkOtpConfirm ? (
                            <div className="loaderCheck text-center">
                                <CircularProgress />
                            </div>
                        ) : (
                            'Unlock my account'
                        )}
                    </ButtonNew>
                    <div className="link" onClick={() => handleCancelBtn()}>
                        Cancel
                    </div>
                </div>
            )}
            {showUnlockContent2 ? (
                <div className="settingsOuter">
                    <div className="settingsTitle">Confirm Account Unlock</div>
                    <div className="InputField">
                        <div className="imeiText">Enter one time password</div>
                        <TextFieldComponent
                            value={otpNum}
                            type="text"
                            onChange={(e: any) => {
                                if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                    otpHandler(e);
                                }
                            }}
                            maxlength={6}
                            error={otpErr !== ''}
                        />
                        <div className="zipCodeError">
                            {otpErr ? otpErr : otpErr !== '' ? 'Please enter the Otp.' : ''}
                        </div>

                        <div className="limit-div">{otpNum && otpNum.length ? otpNum.length : '0'}/6</div>
                    </div>

                    <ButtonNew className="supportCTA" primary={true} onClick={() => confirmOtpHandler(otpNum)}>
                        {checkOtpConfirm ? (
                            <div className="loaderCheck text-center">
                                <CircularProgress />
                            </div>
                        ) : (
                            'Confirm'
                        )}
                    </ButtonNew>

                    {enableResendOtpBtn ? (
                        <>
                            {resendOtpLoader ? (
                                <div className="loaderCheck text-center">
                                    <CircularProgress />
                                </div>
                            ) : (
                                <div className="link-reset-otp" onClick={() => resendOtpHandler()}>
                                    Resend One Time Password
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <div className="noteText">
                                Didn’t receive the One Time Password? Retry in{' '}
                                <span className="counter">{counter} seconds.</span>
                            </div>
                        </>
                    )}
                </div>
            ) : null}
            {unlockSucces ? (
                <div className="settingsOuter">
                    <img src={successIcon} />
                    <div className="settingsTitle">Great news!</div>
                    <div className="noteText">Your account has been unlocked.</div>
                    <ButtonNew className="supportCTA mt-2" primary={true} onClick={() => continueHandler()}>
                        Continue
                    </ButtonNew>
                </div>
            ) : null}
            {accountLockUnsuccess && (
                <div className="settingsOuter">
                    <img src={failedIcon} />
                    <div className="settingsTitle mt-3">Account Lock Unsuccessful!</div>
                    <div className="acc-lock-unsuccess">
                        Please contact our Astound Care Team at 1.800.427.8686 for assistance.
                    </div>
                </div>
            )}
            <Footer isFixed={true} />
        </div>
    );
}

export default Settings;
